export default __webpack_public_path__ + "static/media/flag.754dfe02.svg";